import { render, staticRenderFns } from "./ContractViewsOverlappingRevisions.yaml?vue&type=template&id=a2ecf99a&component"
import script from "./ContractViewsOverlappingRevisions.yaml?vue&type=script&lang=ts&component"
export * from "./ContractViewsOverlappingRevisions.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports